import {
  IGetMarketTrandOptions,
  TGetMarketTrandResponse_1,
  IGetMarketTrandResponse200,
  IGetMarketTrandResponse400,
  TGetMarketTrandResponseError,
  fetchGetMarketTrand,
} from 'shared/repositories/valuation-offer-history/v1/get-market-trand';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IMarketTrendsData } from 'shared/types/marketTrends';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';
import { assertResponseError } from 'shared/utils/errors';
import { request } from 'shared/utils/request';

type TParameters = TRequestParamsWithoutHttpApi<
  IGetMarketTrandOptions<IGetMarketTrandResponse200, IGetMarketTrandResponse400>
>;

export const fetchMarketTrends = async (
  context: IApplicationContext,
  parameters: TParameters,
): Promise<IMarketTrendsData | null> =>
  request<IMarketTrendsData | null, TParameters, TGetMarketTrandResponse_1, TGetMarketTrandResponseError>(context, {
    parameters,
    domain: 'fetchMarketTrends',
    defaultValue: null,
    fetchFunction: fetchGetMarketTrand,
    errorHandler: assertResponseError,
  });
